import { ShortCode } from '@highereducation/wordpress';
import { ExpertQuote } from '@highereducation/hen-ui';

type ExpertQuoteShortcodeProps = {
  quote?: string;
  'expert-name'?: string;
  'expert-role'?: string;
  'expert-avatar-src'?: string;
  'expert-avatar-fallback'?: string;
  'expert-href'?: string;
  [key: string]: unknown;
};

/**
 * ExpertQuoteShortcode - Shortcode wrapper for ExpertQuote (blockquote with quote text and expert attribution).
 *
 * @example
 * [hen-ui-expert-quote quote="Education is the most powerful weapon which you can use to change the world." expert-name="Nelson Mandela" expert-role="Former President" expert-href="/profile" /]
 */
export const ExpertQuoteShortcode: ShortCode<ExpertQuoteShortcodeProps> = {
  component: ({
    quote = '',
    'expert-name': expertName = '',
    'expert-role': expertRole = '',
    'expert-avatar-src': expertAvatarSrc,
    'expert-avatar-fallback': expertAvatarFallback,
    'expert-href': expertHref,
  }) => {
    if (!quote || !expertName || !expertRole) return null;
    return (
      <ExpertQuote
        quote={quote}
        expertName={expertName}
        expertRole={expertRole}
        expertAvatarSrc={expertAvatarSrc}
        expertAvatarFallback={expertAvatarFallback}
        expertHref={expertHref}
      />
    );
  },
};
